import React from 'react'
import PropTypes from 'prop-types'

function FormContainer({
  className,
  heading,
  disclaimer,
  children,
  isSubmitted,
  confirmation,
  ...otherProps
}) {
  return (
    <div
      className={`mz-form-container ${isSubmitted ? 'submitted' : ''} ${className}`}
      {...otherProps}
    >
      {
        (confirmation && isSubmitted) && (
          <div className="mz-form-container__confirmation">
            {confirmation}
          </div>
        )
      }

      <div className="mz-form-container__inner">
        {heading && (
          <div className="mz-form-container__heading">
            {heading}
          </div>
        )}

        {children}

        {disclaimer && (
          <div className="mz-form-container__disclaimer label label--tight">
            {disclaimer}
          </div>
        )}
      </div>

    </div>
  )
}

FormContainer.propTypes = {
  className: PropTypes.string,
  heading: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array, // react-parser
    PropTypes.object,
  ]),
  disclaimer: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array, // react-parser
    PropTypes.object,
  ]),
  isSubmitted: PropTypes.bool,
  confirmation: PropTypes.object,
}

FormContainer.defaultProps = {
  className: '',
  isSubmitted: false,
}

export default FormContainer
